<template>
  <div>
    <div @click="modal = !modal" class="chat" :class="[position == 'left' ? 'left' : 'right']">
      <img :src="StaticImageUrl+'assets/images/support-icon.png'">
      از من بپرس 
    </div>

    <transition name="fade">
      <div v-if="modal && !authenticate" class="chat-box number-form" :class="[position == 'left' ? 'left' : 'right']">
        <div @click="modal = !modal" class="close-box">
          <i class="mdi mdi-close"></i>
        </div>
        <div class="number-form">
          <p class="label mt-2">کاربر گرامی جهت ارائه ی بهتر خدمات لطفا اطلاعات خواسته شده را تکمیل نمایید.</p>
          <div class="input-wrapper">
            <div class="input-inner">
              <div class="input-box">
                <input v-model="form.fullname" placeholder="نام و نام خانوادگی خود را وارد کنید" />
              </div>
            </div>
            <div v-if="errors_send.fullname" class="m-2 s text-danger">
              <small>{{errors_send.fullname[0]}}</small>
            </div>
          </div>
          <div class="input-wrapper">
            <div class="input-inner">
              <div class="input-box">
                <the-mask class="latin-input-1" :masked="true" v-model="form.number" placeholder="شماره تماس خود را وارد کنید" :mask="[
                  '#################'
                ]" />
              </div>
            </div>
            <div v-if="errors_send.number" class="m-2 s text-danger">
              <small>{{errors_send.number[0]}}</small>
            </div>
          </div>
          <div class="btn-wrapper text-center">
            <button @click="startChat()" class="--btn --btn-md --btn-theme">شروع گفت و گو</button>
          </div>
        </div>
      </div>
    </transition>
<!--     
    <transition name="fade">
    <div v-if="guest_number && modal && !authenticate" class="chat-box verifycode-form">
      <div @click="modal = !modal" class="close-box"><img src="assets/images/times-dark.svg" alt=""></div>
      <div class="verifycode-form">
        <p class="label">کد ارسال شده به تلفن همراه خود را وارد کنید</p>
        <div class="input-wrapper">
          <CodeInput :loading="false" :fieldWidth="30" class="input" v-on:change="onChange" v-on:complete="onComplete" />
        </div>
        <div v-if="errorMessage" class="alert my-1 alert-danger">
          {{errorMessage}}
        </div>
        <div class="btn-wrapper text-center">
          <button class="--btn --btn-md --btn-theme" @click="VerifyCode">تایید کد</button>
        </div>
      </div>
    </div>
    </transition> -->

    <transition name="fade">
    <div v-if="authenticate && modal" class="chatroom" :class="[position == 'left' ? 'left' : 'right']">
      <div class="chatroom-header">
        <div class="icon-group">
          <span @click="modal = !modal" class="icon-item">
          <i class="mdi mdi-close"></i>
          </span>
          <!-- <span class="icon-item"><i class="fa fa-cog"></i></span>
          <span class="icon-item"><i class="fa fa-video-camera"></i></span>
          <span class="icon-item"><i class="fa fa-plus"></i></span> -->
        </div>
        <div class="name">کارشناس ارزینه  <i class="fa fa-circle"></i></div>
      </div>

      <div ref="container" class="chatroom-body">

        <template v-if="chat.id">
          <div v-for="msg in chat.messages" :key="msg.id">

            <div v-if="msg.sender == 'admin'" class="right-msg">
              <div class="icon">
                <img :src="StaticImageUrl+'assets/img/empty-user.png'" alt="">
              </div>
              <div class="msg-text">
                <pre>{{msg.text}}</pre>
              </div>
            </div>
            
            <div v-if="msg.sender == 'user'" class="left-msg">
              <div class="msg-text">
                <pre>{{msg.text}}</pre>
              </div>
              <div class="icon">
                <img :src="StaticImageUrl+'assets/img/empty-user.png'" alt="">
              </div>
            </div>

          </div>
        </template>

      </div>

      <div class="chatroom-footer">
        <div class="text-input">
          <textarea @keydown.enter.prevent="sendMessage" class="text-area" v-model="message" placeholder="چیزی بنویسید"></textarea>
          <div @click="sendMessage" class="send-btn">
            <i class="fa fa-send"></i>
          </div>
        </div>
        <!-- <div class="options">
          <div class="icon-group">
            <span class="icon-item"><i class="fa fa-file"></i></span>
            <span class="icon-item"><i class="fa fa-file-photo-o"></i></span>
            <span class="icon-item"><i class="fa fa-video-camera"></i></span>
            <span class="icon-item"><i class="fa fa-plus"></i></span>
          </div>
        </div> -->
      </div>
    </div>
    </transition>

  </div>
</template>
<script>
import CodeInput from "vue-verification-code-input";
import {TheMask} from 'vue-the-mask'
import {io} from 'socket.io-client';
export default {
  name: 'ChatBtn',
  components:{
    CodeInput,
    TheMask
  },
  data : () => ({
    modal : false,
    form : {},
    guest_user_number : null,
    message : '',
    authenticate : false,
    errorMessage : null,
    errors_send : {},
    chat : {},
    socket : null
  }),
  props:{
    position: {
      type: String,
      default: 'left'
    }
  },
  watch:{
    '$route.query.support': {
      handler: function(support) {
        if(support)
        {
          this.modal = true
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    startChat(){
      this.activeLoading(true)
      this.$axios.post(`startChat` , this.form)
      .then(res => {
        const e = this.form.number
        this.guest_user_number = e
        this.$cookies.set("user_number", e , 60*60*24);
        this.socket.emit('new_chat');
        this.authenticate = true
        this.getChat(e)
        this.activeLoading(false)
      })
      .catch(err => {
        this.errors_send = err.response.data.errors
        this.activeLoading(false)
      });
    },
    getChat(number){
      this.$axios.get(`getChatDetails/`+number)
      .then(res => {
        if(res.data.data){
          this.chat = res.data.data
        }
          

        if(this.authenticate && this.modal){
          const container = this.$refs.container;
          container.scrollTop = container.scrollHeight;
        }
      })
      .catch(err => {
      });
    },
    sendMessage(evt){
      if(this.message == ''){
        return
      }
      if (evt.keyCode == 13 && !evt.shiftKey) {
        console.log(this.guest_user_number);
        this.$axios.post(`sendChatMessage` , {message : this.message , number : this.guest_user_number})
        .then(res => {
          this.message = ''
          this.socket.emit('new_chat_message' , this.guest_user_number);
        })
        .catch(err => {
        });

      }
    },
  },
  computed:{
  },
  mounted() {
    this.socket = io(this.socketUrl);

    const number = $cookies.get('user_number');
    if(number){
      this.guest_user_number = number;
      this.authenticate = true;
      this.getChat(number)
    }else{
      if(this.authenticated){
        const status = this.userData.user_detail.user_status;
        if(status == 2){
          const saved_number = this.userData.mobile_number
          if(saved_number){
            this.$cookies.set("user_number", saved_number , 60*60*24*30);
            this.guest_user_number = saved_number;
            this.authenticate = true;

            this.getChat(saved_number)
          }
        }
      }
    }
    

    this.socket.on('new_chat_message', (data) => {
      console.log(data);
      if(this.guest_user_number && this.guest_user_number == data){
        this.getChat(this.guest_user_number)
      }
    });

  },
  updated() {
    if(this.authenticate && this.modal){
      const container = this.$refs.container;
      container.scrollTop = container.scrollHeight;
    }
  }
}
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: transform .3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scale(0);
}
</style>